import React, { Component } from 'react';
import { getTranslation } from '../Utilities/GetTranslation';

class HtmlLegendTitle extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        if (this.props.onClick == null) {
            return;
        }
        this.props.onClick(e);
    }

    render() {
        return (
            <h4 className="legend-title">
                {this.props.title}
                {this.props.readonly
                    ? "" :
                    <a href="# " className="pull-right hidden-print" onClick={this.onClick}>
                        <span className="sr-only">{getTranslation("sns.general.screenreader.edit")}</span><i className="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                }                                  
            </h4>
        );
    }
}

export default HtmlLegendTitle;


// WEBPACK FOOTER //
// ./src/Fields/HtmlLegendTitle.js